import moment from 'moment';

export default function time(value) {
  if (value) {
    return moment(String(value)).format('HH:mm');
  }

  return value;
}
